export default __webpack_public_path__ + "static/media/open-jobs-user-inactive.404da9da.svg";